import React from 'react';
import heroBg from '../../assets/sas_hero_new.png';

const SindhiLetters = ['ا', 'ب', 'ٻ', 'ڀ', 'ت', 'ٿ', 'ٽ', 'ٺ', 'ث', 'ج', 'ڄ', 'ڃ', 'چ', 'ڇ', 'ح', 'خ', 'د', 'ڌ', 'ڏ', 'ڊ', 'ڍ', 'ذ', 'ر', 'ڙ', 'ز', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ڦ', 'ق', 'ڪ', 'ک', 'گ', 'ڳ', 'ڱ', 'ل', 'م', 'ن', 'ڻ', 'و', 'ھ', 'ء', 'ي'];

export const FloatingLetters = () => <div className="floating-letters">
  {[...Array(25)].map((_, i) => {
    const letter = SindhiLetters[Math.floor(Math.random() * SindhiLetters.length)];
    const left = Math.random() * 100;
    const delay = Math.random() * 20;
    const duration = 15 + Math.random() * 20;
    const size = 1 + Math.random() * 3;
    return <div key={i} className="letter" style={{
      left: `${left}%`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      fontSize: `${size}rem`,
      opacity: size > 3 ? 0.03 : 0.08
    }}>
      {letter}
    </div>;
  })}
</div>;

export default function HeroBackground() {
  return (
    <>
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: `url(${heroBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        opacity: 0.15,
        zIndex: 0,
        pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(to bottom, transparent, rgba(10,25,47,0.4))',
        zIndex: 1
      }} />
      <FloatingLetters />
    </>
  );
}
